import type { SxProps, Theme } from "@mui/material";

export const gridStyles: SxProps = (theme: Theme) => ({
  background: theme.palette.box1.main,
  mb: 4,
  borderRadius: 2,
  boxShadow: 1,
  color: theme.palette.box1.contrastText,

  ".MuiDataGrid-columnHeaders": {
    ".MuiDataGrid-columnHeader": {
      "&:focus-within": { outline: "none" },
    },

    "& .MuiDataGrid-iconSeparator": {
      display: "none",
    },
  },

  "& .MuiDataGrid-container--top [role=row]": {
    background: "transparent",
  },

  "& .MuiDataGrid-columnHeaderTitle": {
    fontWeight: "bold",
  },

  "&, [class^=MuiDataGrid]": { borderLeft: "none", borderRight: "none" },

  "& .MuiDataGrid-cell:focus, .MuiDataGrid-cell:focus-within": {
    outline: "none",
  },

  "& .MuiDataGrid-overlayWrapper, & .MuiDataGrid-overlayWrapperInner": {
    minHeight: "52px",
  },

  "& .MuiDataGrid-filler": {
    display: "none",
  },
});

export const gridClickableRowStyles: SxProps = () => ({
  "& .MuiDataGrid-row": {
    cursor: "pointer",
  },
});

export const barStyles: SxProps = (theme: Theme) => ({
  display: "flex",
  width: "100%",
  p: 1,
  mb: 2,
  background: theme.palette.box1.main,
  borderRadius: 2,
  boxShadow: 1,
  color: theme.palette.box1.contrastText,
  alignItems: "center",
});
